import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentMachine: {},
  pristineMachine: {},
  editorErrors: {},
};

export const machinesSlice = createSlice({
 name: "machines",
 initialState,
 reducers: {
  setMachine: (state, action) => {
   state.currentMachine = action.payload;
   state.pristineMachine = action.payload;
  },
  editMachine: (state, action) => {
   state.currentMachine = { ...state.currentMachine, ...action.payload };
  },
  setEditorErrors: (state, action) => {
    state.editorErrors = action.payload;
  },
 },
});

export const selectEditorErrors = (state) => state.machinesReducer.editorErrors;
export const selectMachines = (state) => state.machinesReducer.machines;
export const selectCurrentMachine = (state) => state.machinesReducer.currentMachine;
export const selectPristineMachine = (state) => state.machinesReducer.pristineMachine;

export const { editMachine, setMachine, setEditorErrors } = machinesSlice.actions;

export default machinesSlice.reducer;
